import type { CSSProperties } from 'react'

interface BrandAssetProps {
  className?: string
  title?: string
}

interface OnzoeLogoProps extends BrandAssetProps {
  markClassName?: string
}

interface VoiceSignalProps extends BrandAssetProps {
  state?: 'idle' | 'listening' | 'speaking' | 'thinking'
}

const brandStyle = {
  '--onzoe-signal-cyan': 'var(--brand-voice-cyan, #20D9FF)',
  '--onzoe-signal-amber': 'var(--brand-solar-amber, #FFB454)',
} as CSSProperties

export function OnzoeMark({ className = '', title = 'Onzoe' }: BrandAssetProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 96 96"
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
      style={brandStyle}
    >
      <rect x="8" y="37" width="8" height="22" rx="4" fill="var(--onzoe-signal-cyan)" />
      <rect x="20" y="27" width="8" height="42" rx="4" fill="var(--onzoe-signal-cyan)" />
      <rect x="32" y="16" width="8" height="64" rx="4" fill="var(--onzoe-signal-cyan)" />
      <rect x="44" y="8" width="8" height="80" rx="4" fill="var(--onzoe-signal-amber)" />
      <rect x="56" y="16" width="8" height="64" rx="4" fill="var(--onzoe-signal-cyan)" />
      <rect x="68" y="27" width="8" height="42" rx="4" fill="var(--onzoe-signal-cyan)" />
      <rect x="80" y="37" width="8" height="22" rx="4" fill="var(--onzoe-signal-cyan)" />
    </svg>
  )
}

export function OnzoeVoiceSignal({ className = '', title = '', state = 'idle' }: VoiceSignalProps) {
  return (
    <span className={`onzoe-voice-signal onzoe-voice-signal--${state} ${className}`.trim()}>
      <OnzoeMark title={title} />
    </span>
  )
}

export function OnzoeLogo({ className = '', markClassName = '', title = 'Onzoe' }: OnzoeLogoProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 590 96"
      role="img"
      aria-label={title}
      style={brandStyle}
    >
      <g className={markClassName}>
        <g fill="var(--onzoe-signal-cyan)">
          <rect x="8" y="37" width="8" height="22" rx="4" />
          <rect x="20" y="27" width="8" height="42" rx="4" />
          <rect x="32" y="16" width="8" height="64" rx="4" />
          <rect x="56" y="16" width="8" height="64" rx="4" />
          <rect x="68" y="27" width="8" height="42" rx="4" />
          <rect x="80" y="37" width="8" height="22" rx="4" />
        </g>
        <rect x="44" y="8" width="8" height="80" rx="4" fill="var(--onzoe-signal-amber)" />
      </g>
      <g fill="currentColor">
        <path fillRule="evenodd" d="M145 10C119 10 101 27 101 48s18 38 44 38 44-17 44-38-18-38-44-38Zm0 16c16 0 27 9 27 22s-11 22-27 22-27-9-27-22 11-22 27-22Z" />
        <path d="M204 84V12h18l34 45V12h18v72h-18l-34-45v45h-18Z" />
        <path d="M288 12h72v16l-47 40h47v16h-74V68l47-40h-45V12Z" />
        <path fillRule="evenodd" d="M416 10c-26 0-44 17-44 38s18 38 44 38 44-17 44-38-18-38-44-38Zm0 16c16 0 27 9 27 22s-11 22-27 22-27-9-27-22 11-22 27-22Z" />
        <path d="M475 12h72v16h-54v12h47v16h-47v12h54v16h-72V12Z" />
      </g>
    </svg>
  )
}
